import revokeTokenHandler from '../../pattern_utilities/revokeTokenHandler';
import { push } from 'react-router-redux';

import addCookieWithConsent from '../../pattern_utilities/addCookieWithConsent';
import { addToast, dismissToast } from '../actions.export.js'

var pf_config = require('../../pf_config.json');
var Cookies = require('js-cookie');



////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// CONFIRM EMAIL
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////


export const requestConfirmEmail = credentials => {
  return {
    type: 'REQUEST_CONFIRM_EMAIL',
    data: {
      lastSubmit: credentials
    }
  }
}

export const receiveConfirmEmailSuccess = data => ({
  type: 'RECEIVE_CONFIRM_EMAIL_SUCCESS',
  data
})

export const receiveConfirmEmailFail = data => ({
  type: 'RECEIVE_CONFIRM_EMAIL_FAIL',
  data
})

export const tryToConfirmEmail = packet => dispatch => {
  dispatch(requestConfirmEmail(packet));

  var headers = {
    "Content-Type": "application/json"
  }
  var token = Cookies.get(process.env.REACT_APP_COOKIE_AUTH);
  if(token) headers.Authorization = "Bearer " + token;
  
  return fetch('/api/users/confirm-email', {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveConfirmEmailSuccess(json));
      addCookieWithConsent(process.env.REACT_APP_COOKIE_AUTH, json.token, dispatch);
      dispatch(addToast({
        title: "Email Confirmed! 👍",
        detail: "Thanks your confirming your email address. This helps us ensure your account is safe.",
        func: 'cookieToastDismissed',
        autoDismiss: 5000,
        buttons: [
          {
            display: "Dismiss",
            dismissOnClick: true
          }
        ]
      }));
      dispatch(dismissToast({id: 'verify'}))
      return dispatch(push('/'));
    })
    .catch(e => {
      revokeTokenHandler(e);
      dispatch(receiveConfirmEmailFail({errors:e, lastSubmit: packet}));
      return dispatch(push('/404'));
    })
}


// WEBPACK FOOTER //
// ./src/actions/user/a.u.POST.confirm-email.js